import React, { useState, useEffect } from "react";
import axios from "axios";
import { motion } from "framer-motion";
import { SERVER_URL } from "../../constants";

const HomBannerChanges = () => {
  const [banners, setBanners] = useState([]);
  const [bannerImageURL, setBannerImageURL] = useState("");
  const [mainTitle, setMainTitle] = useState("");
  const [subTitle, setSubTitle] = useState("");
  const [description, setDescription] = useState("");
  const [messages, setMessages] = useState([{ text: "", color: "", gradient: "" ,text2:"",color2:""}]);
  const [editId, setEditId] = useState(null);

  // Fetch existing banners
  useEffect(() => {
    const fetchBanners = async () => {
      try {
        const response = await axios.get(`${SERVER_URL}/api/v1/hero-banner`);
        setBanners(response.data.banners);
      } catch (error) {
        console.error("Error fetching banners:", error);
      }
    };
    fetchBanners();
  }, []);

  const handleFileChange = async (e) => {
    const file = e.target.files[0];
    if (file) {
      const formData = new FormData();
      formData.append("file", file);
      formData.append("upload_preset", "unsigned_preset");
      formData.append("cloud_name", "dpgf1rkjl");

      try {
        const response = await axios.post(
          "https://api.cloudinary.com/v1_1/dpgf1rkjl/image/upload",
          formData
        );
        setBannerImageURL(response.data.secure_url);
      } catch (error) {
        console.error("Error uploading image:", error);
      }
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    const newBanner = {
      bannerImage: bannerImageURL,
      mainTitle,
      subTitle,
      description,
      messages,
    };

    try {
      if (editId) {
        const response = await axios.put(
          `${SERVER_URL}/api/v1/hero-banner/${editId}`,
          newBanner
        );
        setBanners(
          banners.map((banner) =>
            banner._id === editId ? response.data.updatedBanner : banner
          )
        );
      } else {
        const response = await axios.post(
          `${SERVER_URL}/api/v1/hero-banner`,
          newBanner
        );
        setBanners([...banners, response.data.banner]);
      }

      resetForm();
    } catch (error) {
      console.error("Error submitting banner:", error);
    }
  };

  const handleDelete = async (id) => {
    try {
      await axios.delete(`${SERVER_URL}/api/v1/hero-banner/${id}`);
      setBanners(banners.filter((banner) => banner._id !== id));
    } catch (error) {
      console.error("Error deleting banner:", error);
    }
  };

  const handleEdit = (banner) => {
    setEditId(banner._id);
    setBannerImageURL(banner.bannerImage);
    setMainTitle(banner.mainTitle);
    setSubTitle(banner.subTitle);
    setDescription(banner.description);
    setMessages(banner.messages || [{ text: "", color: "", gradient: "",text2:"",color2:"" }]);
  };

  const resetForm = () => {
    setEditId(null);
    setBannerImageURL("");
    setMainTitle("");
    setSubTitle("");
    setDescription("");
    setMessages([{ text: "", color: "", gradient: "" ,text2:"",color2:""}]);
  };

  const handleAddMessage = () => {
    setMessages([...messages, { text: "", color: "", gradient: "" ,text2:"",color2:""}]);
  };

  const handleRemoveMessage = (index) => {
    const updatedMessages = messages.filter((_, i) => i !== index);
    setMessages(updatedMessages);
  };

  const handleMessageChange = (index, field, value) => {
    const updatedMessages = [...messages];
    updatedMessages[index][field] = value;
    setMessages(updatedMessages);
  };

  return (
    <div className="relative p-10 py-14 bg-gradient-to-br from-purple-300 to-pink-300 rounded-lg shadow-lg max-w-4xl mx-auto overflow-hidden z-10 mt-6 mb-6">
      <motion.h2 className="text-2xl font-bold mb-6 text-center text-indigo-800">
        Manage Hero Banners
      </motion.h2>
      <motion.form
        onSubmit={handleSubmit}
        className="space-y-5 bg-white bg-opacity-90 p-6 rounded-lg shadow-md"
      >
        <div>
          <label className="block mb-1 font-semibold text-gray-800">
            Main Title
          </label>
          <input
            type="text"
            value={mainTitle}
            onChange={(e) => setMainTitle(e.target.value)}
            className="border border-gray-300 rounded-lg p-2 w-full"
            required
          />
        </div>
        <div>
          <label className="block mb-1 font-semibold text-gray-800">
            Subtitle
          </label>
          <input
            type="text"
            value={subTitle}
            onChange={(e) => setSubTitle(e.target.value)}
            className="border border-gray-300 rounded-lg p-2 w-full"
            required
          />
        </div>
        <div>
          <label className="block mb-1 font-semibold text-gray-800">
            Description
          </label>
          <textarea
            value={description}
            onChange={(e) => setDescription(e.target.value)}
            className="border border-gray-300 rounded-lg p-2 w-full"
            rows="3"
            required
          />
        </div>
        <div>
          <label className="block mb-1 font-semibold text-gray-800">
            Banner Image
          </label>
          <input
            type="file"
            onChange={handleFileChange}
            className="border border-gray-300 rounded-lg p-2 w-full"
            accept="image/*"
          />
          {bannerImageURL && (
            <img
              src={bannerImageURL}
              alt="Preview"
              className="mt-4 w-full h-48 object-cover rounded-lg"
            />
          )}
        </div>
        <div>
          <h3 className="font-semibold text-gray-800 mb-2">Messages</h3>
          {messages.map((message, index) => (
            <div key={index} className="space-y-2 mb-4 border p-4 rounded-lg">
              <input
                type="text"
                value={message.text}
                onChange={(e) =>
                  handleMessageChange(index, "text", e.target.value)
                }
                placeholder="Message Text"
                className="border border-gray-300 rounded-lg p-2 w-full"
                required
              />
              <select
                value={message.color}
                onChange={(e) =>
                  handleMessageChange(index, "color", e.target.value)
                }
                className="border border-gray-300 rounded-lg p-2 w-full"
                required
              >
                <option value="" disabled>
                  Select Color
                </option>
                <option value="text-black">Black</option>
                <option value="text-white">White</option>
              </select>
              <input
                type="text"
                value={message.text2}
                onChange={(e) =>
                  handleMessageChange(index, "text2", e.target.value)
                }
                placeholder="Message Text"
                className="border border-gray-300 rounded-lg p-2 w-full"
                required
              />
              <select
                value={message.color2}
                onChange={(e) =>
                  handleMessageChange(index, "color2", e.target.value)
                }
                className="border border-gray-300 rounded-lg p-2 w-full"
                required
              >
                <option value="" disabled>
                  Select Color
                </option>
                <option value="text-black">Black</option>
                <option value="text-white">White</option>
              </select>
              
              <input
                type="text"
                value={message.gradient}
                onChange={(e) =>
                  handleMessageChange(index, "gradient", e.target.value)
                }
                placeholder="e.g., bg-gradient-to-r from-yellow-400 to-orange-500"
                className="border border-gray-300 rounded-lg p-2 w-full"
                required
              />
              <button
                type="button"
                onClick={() => handleRemoveMessage(index)}
                className="bg-red-500 text-white px-3 py-1 rounded hover:bg-red-600"
              >
                Remove Message
              </button>
            </div>
          ))}
          <button
            type="button"
            onClick={handleAddMessage}
            className="bg-blue-500 text-white px-3 py-1 rounded hover:bg-blue-600"
          >
            Add Message
          </button>
        </div>
        <button
          type="submit"
          className="w-full bg-indigo-600 text-white font-semibold px-4 py-2 rounded-lg shadow hover:bg-indigo-700"
        >
          {editId ? "Update Banner" : "Add Banner"}
        </button>
        {editId && (
          <button
            type="button"
            onClick={resetForm}
            className="w-full mt-4 bg-gray-500 text-white font-semibold px-4 py-2 rounded-lg shadow hover:bg-gray-600"
          >
            Cancel Edit
          </button>
        )}
      </motion.form>

      <div className="mt-8">
        <h3 className="text-lg font-semibold mb-4">Existing Banners</h3>
        <ul className="space-y-4">
          {banners.map((banner) => (
            <li
              key={banner._id}
              className="flex items-center justify-between bg-white p-4 rounded-lg shadow"
            >
              <img
                src={banner.bannerImage}
                alt="Banner"
                className="w-20 h-12 object-cover rounded-md"
              />
              <div className="flex-1 ml-4">
                <p className="font-semibold">{banner.mainTitle}</p>
                <p className="text-sm text-gray-600">{banner.subTitle}</p>
                {banner.messages.map((message, index) => (
                  <p
                    key={index}
                    className={`${message.color} ${message.gradient} text-xs`}
                  >
                    {message.text}
                  </p>
                ))}
              </div>
              <div className="flex gap-2">
                <button
                  onClick={() => handleEdit(banner)}
                  className="bg-blue-500 text-white px-3 py-1 rounded hover:bg-blue-600"
                >
                  Edit
                </button>
                <button
                  onClick={() => handleDelete(banner._id)}
                  className="bg-red-500 text-white px-3 py-1 rounded hover:bg-red-600"
                >
                  Delete
                </button>
              </div>
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
};

export default HomBannerChanges;
